var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next"},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disabled,"large":"","block":"","loading":_vm.loading,"to":_vm.to}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }